import 'assets/scss/test.scss';
import React from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import DNS from 'components/DNS/dns.js';
// react plugin for creating notifications over the dashboard
import {isMobile, isTablet} from 'react-device-detect';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// import HAGDIMG from './HaveAGoodDay.png'
import {
  Card,
  CardDeck,
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import Pdf from '@mikecousins/react-pdf';

// import TabComponent from 'components/tabs/TabComponent';
// import {ReactComponent as Document} from 'assets/documents_1_.svg';
// import {motion} from 'framer-motion/dist/framer-motion';
import ModalViewConciergerie from './modalVIEW';
import axios from 'axios';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';

/**
 * This function handle all the event and style in the conciergerie page.
 * @function Reservations
 * @return {HTML} the conciergerie's page.
*/
function Conciergerie() {
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const token = useSelector((state) => state.token);
  const [showModal, setShowModal] = React.useState(false);
  const [showDoclink, setDoclink] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showCategory, setShowCategory] = useState(false);
  const [showCategoryElem, setCategoryElem] = useState([]);
  const [showTabsSelected, setTabsSelected] = useState('documment');
  const [showConciergerieDynamic, setConciergerieDynamic] = useState(false);
  const {t} = useTranslation();
  const [adoc, setDoc] = useState(
      {
        data: null,
        error: false,
      },
      [],
  );
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };

  useEffect(() => {
    getDocument();
    getConciergerieDynamic();
  }, []);

  const requestOptionsAxios = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };


  const getConciergerieDynamic = () => {
    axios.get(DNS + '/area/getConciergerieDynamic/' + currentBuilding['currentbuildingRedux'].pk + '/', requestOptionsAxios)
        .then((response) => {
          if (response.data['fields']) {
            setConciergerieDynamic(true);
            setShowCategory(true);
            getCategory();
          } else {
            setConciergerieDynamic(false);
          }
        });
  };

  const getCategory = () => {
    axios.get(DNS + '/' + currentBuilding['currentbuildingRedux'].pk + '/category/crudCategory/', requestOptionsAxios)
        .then((response) => {
          setCategoryElem(response.data);
        });
  };

  const getDocument = () => {
    fetch(
        DNS + '/accueil/crudAccueil/' +
        currentBuilding['currentbuildingRedux'].pk +
        '/',
        requestOptions,
    ).then(async (response) => {
      const data = await response.json();
      if (data.fields) {
        // console.log(data);
        setDoc({
          data: data.fields,
          error: false,
        });
        return;
      } else {
        setDoc({
          data: data.fields,
          error: false,
        });
        return;
      }
    });
  };

  let contentDesk = null;
  if (adoc.data) {
    contentDesk =
      adoc.data
          .slice(0)
          .reverse()
          .filter((val) => {
            if (val.docType.toLowerCase() == 'concierge' || val.docType.toLowerCase() == 'tarifaire') {
              if (searchTerm == '') {
                return val;
              } else if (
                val.title.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return val;
              } else if (
                val.time.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return val;
              } else if (
                val.description.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return val;
              }
            }
          })
          .map((doc, key) => (
            <Col key={key} lg={3}>
              <div
                className={'mb-3'}
                id={doc.pk}
                key={key}
                style={{display: 'grid', placeItems: 'center'}}
              >
                <Pdf
                  file={doc.document}
                  style={{cursor: 'pointer'}}
                  page={1}
                  className={'pdfFstPage'}
                  scale={0.2}
                  onClick={() => {
                    setShowModal(true), setDoclink(doc.document);
                  }}
                />
                <div style={{marginTop: 8, textAlign: 'center'}}>
                  <h5 style={{lineHeight: 1}}>{doc.title}</h5>
                  <p style={{lineHeight: 1, fontSize: 15}}>{doc.description}</p>
                  <button
                    onClick={() => {
                      setShowModal(true), setDoclink(doc.document);
                    }}
                    className="btn-primary btn-sm btn-round mr-2 mb-2"
                  >
                    {t(translations.CONCIERGE_BUTTON)}
                  </button>
                </div>
              </div>
              <ModalViewConciergerie showModal={showModal} setShowModal={setShowModal} showDoclink={showDoclink} />
            </Col>
          ));

    contentDesk = contentDesk;
  }

  useEffect(() => {
    if (showCategoryElem && showCategoryElem.length > 0) {
      setTabsSelected(showCategoryElem[0].name);
    }
  }, [showCategoryElem]);

  let showHeaderPhone = [];
  if (showCategoryElem) {
    showHeaderPhone = showCategoryElem.map((category, key) => (
      <a
        key={key}
        style={{backgroundColor: showTabsSelected == category['name'] ? '#fddb31' : 'white', display: 'inline-block', textAlign: 'center', textDecoration: 'none', borderRadius: 10, padding: 12, fontWeight: 'bold'}}
        onClick={() => {
          setShowCategory(true);
          setTabsSelected(category['name']);
        }}
      >{category['name']}
      </a>
    ));
  }
  showHeaderPhone.push(
      <a
        key={'document'}
        style={{backgroundColor: !showCategory ? '#fddb31' : 'white', display: 'inline-block', textAlign: 'center', textDecoration: 'none', borderRadius: 10, padding: 12, fontWeight: 'bold'}}
        onClick={() => {
          setShowCategory(false);
          setTabsSelected('document');
        }}
      >Document
      </a>,
  );

  let conciergerie = null;
  if (showCategoryElem) {
    conciergerie = showCategoryElem.filter((val) => {
      if (searchTerm != '' && val['name'].toLowerCase().includes(searchTerm.toLowerCase())) {
        console.log('val', val);
        return val;
      } else if (searchTerm != '') {
        const returnValue = val['products'].map((elem) => {
          if (elem['name'].toLowerCase().includes(searchTerm.toLowerCase())) {
            return true;
          }
          return false;
        });
        return returnValue.includes(true) ? val : undefined;
      } else {
        return val;
      }
    }).map((category, key) => {
      if (!isMobile || isTablet) {
        if (category['products'].length == 0) {
          return;
        } else {
          return (
            <Col key={key} md="4">
              <div
                className={'mb-5'}
                style={{backgroundColor: 'black', paddingTop: 24, paddingLeft: 8, paddingRight: 8, paddingBottom: 16, borderRadius: 10}}
                id={category.id}
                key={key}
              >
                <h2 style={{textAlign: 'center', color: '#FDDB30', fontSize: 25, fontWeight: 400}}>{category.name.toUpperCase()}</h2>
                <hr
                  style={{
                    color: 'black',
                    backgroundColor: '#FFDB05',
                    height: 1,
                    width: '20%',
                    marginBottom: 16,
                  }}
                />
                {category['products'].map((products, key2) => (
                  <div key={key2} style={{height: 'auto', width: 'auto'}}>
                    <div className="menu-item-name">
                      {products.name}
                    </div>
                    <div className="menu-item-price">
                      {products.price}€
                    </div>
                    {products.description == '' ?
                      null :
                    <div className="menu-item-description">
                      {products.description}
                    </div>
                    }
                  </div>
                ))}
              </div>
            </Col>
          );
        }
      } else {
        if (category['name'] != showTabsSelected) {
          return;
        } else if (category['products'].length == 0) {
          return;
        } else {
          return (
            <Col key={key} md="3">
              <div
                className={'mb-5'}
                style={{backgroundColor: 'black'}}
                id={category.id}
                key={key}
              >
                <h2 style={{paddingTop: 16, fontSize: 25, textAlign: 'center', height: 'auto', color: '#FDDB30'}}>{category.name}</h2>
                <hr style={{color: 'black', backgroundColor: '#FFDB05', height: 1, width: '20%', marginBottom: 16}}/>
                {category['products'].map((products, key2) => (
                  <div key={key2} style={{height: 'auto', width: 'auto'}}>
                    <div className="menu-item-name">
                      {products.name}
                    </div>
                    <div className="menu-item-price">
                      {products.price}€
                    </div>
                    {products.description == '' ?
                        null :
                        <div className="menu-item-description">
                          {products.description}
                        </div>
                    }
                  </div>
                ))}
              </div>
            </Col>
          );
        }
      };
    });
  };

  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card id="PDF-Table">
            <Card.Header>
              {!isMobile || isTablet ?
                  <>
                    <Card.Title as="h4"> {t(translations.CONCIERGE_SUBTITLE2)}</Card.Title>
                    <div style={{width: '100%', height: 'auto'}}>
                      <Row style={{width: '100%', height: 'auto', justifyContent: 'center', alignItems: 'center'}}>
                        { showConciergerieDynamic == true ?
                          <span style={{cursor: 'pointer', color: showCategory == true ? 'white' : '#fddb31', backgroundColor: showCategory == true ? '#fddb31' : 'white', fontWeight: showCategory == true ? 'bold' : 'inherit', padding: 10, borderRadius: 10, fontSize: showCategory == true ? '18px' : '14px'}} onClick={() => {
                            setShowCategory(true);
                            setSearchTerm('');
                          }}>{t(translations.CONCIERGE_SERVICE_TITLE)}</span> :
                          null
                        }
                        <span style={{marginLeft: '5%', cursor: 'pointer', color: showCategory == false ? 'white' : '#fddb31', backgroundColor: showCategory == false ? '#fddb31' : 'white', fontWeight: showCategory == false ? 'bold' : 'inherit', padding: 10, borderRadius: 10, fontSize: showCategory == false ? '18px' : '14px'}} onClick={() => {
                          setShowCategory(false);
                          setSearchTerm('');
                        }}>{t(translations.DOCUMENTS)}</span>
                      </Row>
                    </div>

                    <p className="card-category"><br/></p>
                    <div className="row" style={{paddingTop: '15px'}}>
                      <div id="custom-search-input" >
                        <div className="input-group col-md-12" style={{right: '7%'}}>
                          <input
                            type="text"
                            className="form-control ml-1"
                            placeholder={t(translations.SEARCH)}
                            value={searchTerm}
                            onChange={(event) => {
                              setSearchTerm(event.target.value);
                            }}
                          />
                          <span className="input-group-btn btn btn-primary">
                            <span className=" fas fa-search"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </> :
                    <div style={{display: 'flex', overflow: 'auto', whiteSpace: 'nowrap', gap: 32}}>
                      {showHeaderPhone}
                    </div>
              }
            </Card.Header>
            <Card.Body style={{zIndex: 1}}>
              {showCategory == false ?
                <Row>
                  {contentDesk}
                </Row> :
                <Row>
                  {conciergerie}
                </Row>
              }
              <CardDeck
                style={{flexDirection: 'column', display: 'flex'}}
              ></CardDeck>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Conciergerie;
